import { isEmpty } from "lodash";

export const getCellEntry = (cellMap, valueKey, columnId) =>
  cellMap?.[valueKey]?.[columnId];

export const setCellEntry = (cellMap, valueKey, columnId, entry) => {
  cellMap[valueKey] = { ...cellMap[valueKey], [columnId]: entry };
};

export const removeCellEntry = (cellMap, valueKey, columnId) => {
  const row = cellMap[valueKey];
  if (!row) {
    return;
  }
  delete row[columnId];
  if (isEmpty(row)) {
    delete cellMap[valueKey];
  }
};
